import { apiErrorsActionTypes } from '../actionTypes/apiErrorsActionTypes';

export const unauthorizedErrorAction = () => ({
  type: apiErrorsActionTypes.API_UNAUTHORIZED_ERROR
});
